/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  DeleteHomepagePinMutationResponse,
  DeleteHomepagePinPathParams,
  DeleteHomepagePin400,
  DeleteHomepagePin404,
} from '../types/DeleteHomepagePin'

function getDeleteHomepagePinUrl({
  id,
}: {
  id: DeleteHomepagePinPathParams['id']
}) {
  const res = { method: 'DELETE', url: `/api/v1/homepage/pins/${id}/` as const }
  return res
}

/**
 * @summary Unpin from the homepage
 * {@link /api/v1/homepage/pins/:id/}
 */
export async function deleteHomepagePin(
  { id }: { id: DeleteHomepagePinPathParams['id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    DeleteHomepagePinMutationResponse,
    ResponseErrorConfig<DeleteHomepagePin400 | DeleteHomepagePin404>,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteHomepagePinUrl({ id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
